import React, { useCallback, useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'

type Props = {
    label: string
    onOpenProfile: () => void
    onMessage: () => void
    onFavorite: () => void
    onBlock: () => void
    onEvent: () => void
    onManualDocument: () => void
    blocked: boolean
    busy: boolean
}

export default function BrokerActionsMenu({ label, onOpenProfile, onMessage, onFavorite, onBlock, onEvent, onManualDocument, blocked, busy }: Props): JSX.Element {
    const trigger = useRef<HTMLButtonElement | null>(null), menu = useRef<HTMLDivElement | null>(null)
    const [open, setOpen] = useState(false), [position, setPosition] = useState<{ top: number, left: number } | null>(null)
    const close = useCallback(() => setOpen(false), [])
    const updatePosition = useCallback(() => {
        const rect = trigger.current?.getBoundingClientRect()
        if (!rect) return
        const width = 190, height = 230
        const left = window.innerWidth - rect.right >= width ? rect.right + 6 : Math.max(8, rect.left - width - 6)
        const top = window.innerHeight - rect.bottom >= height ? rect.bottom + 5 : Math.max(8, rect.top - height - 5)
        setPosition({ top, left })
    }, [])
    useEffect(() => {
        if (!open) return
        updatePosition()
        const outside = (event: MouseEvent): void => { if (!trigger.current?.contains(event.target as Node) && !menu.current?.contains(event.target as Node)) close() }
        const escape = (event: KeyboardEvent): void => { if (event.key === 'Escape') close() }
        window.addEventListener('resize', updatePosition); window.addEventListener('scroll', updatePosition, true); document.addEventListener('mousedown', outside); document.addEventListener('keydown', escape)
        return () => { window.removeEventListener('resize', updatePosition); window.removeEventListener('scroll', updatePosition, true); document.removeEventListener('mousedown', outside); document.removeEventListener('keydown', escape) }
    }, [close, open, updatePosition])
    const action = (fn: () => void): void => { close(); fn() }
    return <div className="broker-actions-menu"><button ref={trigger} type="button" aria-label={`Actions for ${label}`} aria-expanded={open} onClick={() => setOpen((value) => !value)}>Actions <span aria-hidden="true">▾</span></button>{open && position && typeof document !== 'undefined' && createPortal(<div ref={menu} className="broker-actions-menu__portal" style={{ top: position.top, left: position.left }}><button onClick={() => action(onOpenProfile)}>Open profile</button><button disabled={busy} onClick={() => action(onMessage)}>Message</button><button onClick={() => action(onFavorite)}>Add to favorites</button><button disabled={busy} onClick={() => action(onBlock)}>{blocked ? 'Unblock' : 'Block'}</button><button onClick={() => action(onEvent)}>Send event</button><button onClick={() => action(onManualDocument)}>Add manual document</button><button disabled>Add reward</button></div>, document.body)}</div>
}
